module.exports = __webpack_public_path__ + "static/img/Contact page top img_mobile.c024045a.jpg";